import { render, staticRenderFns } from "./footer-element.vue?vue&type=template&id=d5fc023c&"
import script from "./footer-element.vue?vue&type=script&lang=js&"
export * from "./footer-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports